import { axiosWithJWT } from '@/api/axiosWithJWT';

export const getBookingTypes = async (_) => {
    const { data } = await axiosWithJWT.get('/api/BookingType/GetList');
    return data;
};
